<script>
import { mapGetters } from 'vuex'

export default {
  name: 'sidebar',
  data () {
    return {
      menu: 'dashboard'
    }
  },
  computed: {
    ...mapGetters(['userIsCompany'])
  }
}
</script>

<template lang="pug">
  ul
    li(:class="{'active': menu === 'dashboard'}",  style="cursor: pointer",  @click.prevent="menu = 'dashboard'")
      router-link(:to="{ name: 'employee.dashboard.index'}")
        span 
        | Dashboard

    li(:class="{'active': menu === 'registration'}",  style="cursor: pointer", @click.prevent="menu = 'registration'")
        span 
        | Perfil Profissional
        ul.sub-item(v-if="menu === 'registration'")
          router-link(:to="{name: 'professional.record.registration.me'}", tag="li", active-class="sub-active")
            span 
            a(href="#") Cadastro
          router-link(:to="{name: 'employee.record.specialities.index'}", tag="li", active-class="sub-active")
            span 
            a(href="#") Especialidade

    li(:class="{'active': menu === 'company'}", style="cursor: pointer", @click.prevent="menu = 'company'")
      span 
      | Estabelecimento
      ul.sub-item(v-if="menu === 'company'")
        router-link(:to="{name: 'professional.company.companies.edit'}", tag="li", active-class="sub-active")
         span 
         a(href="#") Cadastro

        router-link(:to="{name: 'professional.company.addresses.index'}",
          tag="li",
          active-class="sub-active")
         span 
         a(href="#") Local de Atendimento

        router-link(:to="{name: 'professional.company.covenants.index'}",
          tag="li",
          active-class="sub-active")
         span 
         a(href="#") Convênios

        router-link(v-if="userIsCompany", :to="{name: 'professional.company.staffs.index'}",
          tag="li",
          active-class="sub-active")
         span 
         a(href="#") Corpo Clínico

        router-link(:to="{name: 'professional.company.prices.index'}",
          tag="li",
          active-class="sub-active")
         span 
         a(href="#") Honorários

        router-link(:to="{name: 'professional.company.employees.index'}",
           tag="li",
           active-class="sub-active")
          span 
          a(href="#") Funcionários

    li(:class="{'active': menu === 'agenda'}", style="cursor: pointer", @click.prevent="menu = 'agenda'")
      span 
      | Agenda Profissional
      ul.sub-item(v-if="menu === 'agenda'")
        router-link(:to="{name: 'professional.agenda.agendas.index'}",
           tag="li",
           active-class="sub-active")
          span 
          a(href="#") Cadastro

        router-link(:to="{name: 'professional.agenda.rules.index'}",
           tag="li",
           active-class="sub-active")
          span 
          a(href="#") Regras

        router-link(:to="{name: 'professional.agenda.locks.index'}",
           tag="li",
           active-class="sub-active")
          span 
          a(href="#") Bloqueios

    li(:class="{'active': menu === 'schedulings'}")
      router-link(:to="{ name: 'professional.schedulings.index'}")
        span 
        | Agendamentos

    li
      span 
      | Relatórios
    li(:class="{'active': menu === 'curriculum'}", style="cursor: pointer", @click.prevent="menu = 'curriculum'")
      span 
      | Curriculum
      ul.sub-item(v-if="menu === 'curriculum'")
        router-link(:to="{name: 'professional.curriculum.graduations.index'}",
           tag="li",
           active-class="sub-active")
          span 
          a(href="#") Graduação

        router-link(:to="{name: 'professional.curriculum.specializations.index'}",
           tag="li",
           active-class="sub-active")
          span 
          a(href="#") Especialização
</template>



// WEBPACK FOOTER //
// src/layout/employee/sidebar.vue